import { SAFARI_MP4_RECORDERS } from 'app-constants'
import services from 'services'

export default {

  fetchUrl() {
    return services.fetch('/v1/video/url')
  },

  fetchPlaybackUrl(video, useOpentokPreview = false) {
    if (video.recorder && video.recorder === 'opentok' && useOpentokPreview) {
      return services.fetch(
        '/v1/video/opentok-playback-url',
        { method: 'POST', body: { videoUrl: video.videoUrl, filePath: video.filePath } }
      )
    }
    return services.fetch(
      '/v1/video/playback-url',
      { method: 'POST', body: { videoUrl: video.videoUrl } }
    )
  },

  url(url, replace = false) {
    let newUrl = url.replace(/\.flv$/i, '')
    if (replace) {
      newUrl = url.replace(/\?/, '&')
    }
    return newUrl
  },

  downloadBlobs(prefix, videoUrl, recorder, mimetypes, onProgress) {
    const { length } = mimetypes
    const blobs = []
    return this.downloadBlob(prefix, videoUrl, recorder, [...mimetypes], blobs, 0, length, onProgress)
  },

  downloadBlob(prefix, videoUrl, recorder, mimetypes, blobs, index, length, onProgress) {
    if (!mimetypes.length) {
      return Promise.resolve(blobs)
    }

    const mimetypeIndex = SAFARI_MP4_RECORDERS.includes(recorder) ? 1 : 0
    const mimetype = mimetypes[mimetypeIndex]
    let url = `/v1/video/stream/${this.url(videoUrl)}&mimetype=${mimetype}`

    if (recorder === 'safari-rtc') {
      // we have saved both mp4 and webm files because of mimetype check bug, so we need to check which one is available
      url = `/v1/video/stream/${this.url(videoUrl)}&mimetype=${mimetype}&checkMp4andWebm=true`
    }

    return services.xhr(url, {
      method: 'get',
      responseType: 'blob',
      onProgress: (event) => {
        const { lengthComputable, loaded, total } = event
        if (lengthComputable) {
          onProgress({ progress: ((loaded / total) + index) / length })
        }
      },
    })
      .then((data) => {
        const blob = new Blob([data], { type: mimetype })
        blobs.push(blob)
        // NOTE: The old code had mimetypes.shift(), that basically emptied the array as there was only one value "video/webm in the array.
        // Now that mimetypes array has two mimetypes, I tested with removing only the one used from the array but it caused an error.
        // So I assume it's ssupposed to empty it here, as here's the blob is ready for watching. Now that this fnction calls itself with the empty array, 
        // it will return Promise.resolve(blobs)
        // it's a bit confusingly done though

        return this.downloadBlob(prefix, videoUrl, recorder, [], blobs, index + 1, length, onProgress)
      })
  },

  uploadBlobs(prefix, videoUrl, blobs, onProgress, token) {
    const total = blobs.reduce((total, blob) => total + blob.size, 0)
    return this.uploadBlob(prefix, videoUrl, [...blobs], onProgress, token, 0, total)
  },

  uploadBlob(prefix, videoUrl, blobs, onProgress, token, loaded, total) {
    if (!blobs.length) {
      return Promise.resolve()
    }

    const blob = blobs[0]
    const url = `/v1/video/stream/${this.url(videoUrl)}&mimetype=${blob.type}`

    return services.xhr(
      url,
      {
        method: 'post',
        responseType: '',
        blob,
        onProgress: (event) => {
          if (event.lengthComputable) {
            onProgress({ progress: (loaded + event.loaded) / total, total })
          }
        },
      },
      token
    )
      .then(({ error }) => {
        if (error) {
          throw error
        }

        blobs.shift()
        return this.uploadBlob(
          prefix,
          videoUrl,
          blobs,
          loaded + blob.size,
          total,
          onProgress,
          token
        )
      })
  },

  deleteBlobs(prefix, videoUrl, mimetype) {
    const url = `/v1/video/stream/${this.url(videoUrl)}&mimetype=${mimetype}`
    return services.xhr(url, { method: 'delete', responseType: '' })
  },

  uploadScreenshot(prefix, videoUrl, blob) {
    const url = `/v1/video/snapshot/?video=${this.url(videoUrl, true)}`
    return services.xhr(url, { method: 'post', responseType: '', blob })
  },

  createTranscodingJob(video, pollId, context) {
    const body = { video }
    if (context && context === 'embedded') {
      return services.xhr(`/v1/candidate/embedded/${pollId}`, { method: 'put', body })
    }
    return services.xhr(`/v1/admin/videos/uploads/${pollId}`, { method: 'put', body })
  },

  startArchiving(sessionId, uuid, recorderContext) {
    return services.fetch(
      '/v1/video/start-archive',
      { method: 'POST', body: { sessionId, uuid, recorderContext } }
    )
  },

  stopArchiving(archiveId, sessionId, uuid, recorderContext) {
    return services.fetch(
      `/v1/video/stop-archive/${archiveId}`,
      { method: 'POST', body: { sessionId, uuid, recorderContext } }
    )
  },

  adminStartArchiving(sessionId) {
    return services.fetch(
      '/v1/admin/videos/start-archive/',
      { method: 'POST', body: { sessionId } }
    )
  },

  adminStopArchiving(archiveId) {
    return services.fetch(
      `/v1/admin/videos/stop-archive/${archiveId}`
    )
  },

  fetchOpentokSessionData() {
    return services.fetch(
      '/v1/admin/videos/opentok-session'
    )
  },
}
